import styled from "styled-components"

export const NewsItemWrapper = styled.div`
    width: 100%;
    cursor: pointer;
    position: relative;
    &:hover .image{
        img{
            transform: translateY(-10px);
        }
    }
    .image{
        width: 100%;
        height: 250px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 100%;
            max-height: 240px;
            object-fit: contain;
            border-radius: 5px;
            transition: all .3s linear;
        }
    }
    .title{
        margin-top: 8px;
        h1{
            font-size: 1.0rem;
            text-align: center;
            font-weight: 500;
            color: #1c1c1c;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
        }
    }
    .date{
        display: flex;
        align-items: center;
        justify-content: flex-end;
        i{
            margin-right: 4px;
            color: #469ef4;
            margin-bottom: 4px;
        }
        span{
            color: #469ef4;
        }
    }
`
